export default {
      id: "menu__orchestrator_fill-usage",
      viewBox: "0 0 27 28",
      url: __webpack_public_path__ + "img/icons.svg#menu__orchestrator_fill",
      toString: function () {
        return this.url;
      }
    }